// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__5FZ5s","modal__background":"Modal_modal__background__vc486","modal__close":"Modal_modal__close__1+hQb"};